<!--
@create date 2023-10-31
@desc p831.phomemo.com
-->
<template>
  <div class="m08f-guide2-div">
    <div class="scroll-items-div">
      <ul>
        <li
          :class="
            clickName === 'howToVideosRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('howToVideosRef')"
        >
          HOW-TO VIDEOS
        </li>
        <li
          :class="
            clickName === 'driversRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('driversRef')"
        >
          DRIVERS
        </li>
        <li
          :class="
            clickName === 'appDownloadRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('appDownloadRef')"
        >
          APP
        </li>
        <li
          :class="
            clickName === 'blankTemplatesRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('blankTemplatesRef')"
        >
          Download Templates
        </li>
        <li
          :class="
            clickName === 'faqRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('faqRef')"
        >
          FAQ
        </li>
      </ul>
    </div>
    <div class="topContainerDivEx">
      <h1>P831 PORTABLE PRINTER SUPPORT</h1>
      <div class="productDiv">
        <div class="leftDiv">
          <img
            src="https://oss.qu-in.top/printerFiles/phomemo/others/p831Product.png"
            style="margin: 10px auto; width: 200px"
            title="Click to view the product."
            @click="
              () => {
                window.open('https://www.amazon.com/dp/B0C5ZVX8JH?th=1');
              }
            "
          />
        </div>
        <div class="rightDiv">
          <p>
            In addition to the printer support and repair resources on this
            page, also see the following:
          </p>
          <div class="linkDiv">
            <a
              title="Click to learn more"
              @click="
                () => {
                  refreshRecord({ key: 'P831_quickStartGuide' });
                  window.open(
                    'https://oss.qu-in.top/printerFiles/phomemo/others/P831-PhomemoQuickStartGuide.pdf'
                  );
                }
              "
              >Quick Start Guide</a
            >
            |
            <a
              title="Click to learn more"
              @click="
                () => {
                  refreshRecord({ key: 'P831_manual' });
                  window.open(
                    'https://oss.qu-in.top/printerFiles/phomemo/others/P831 英文中性详细说明书.pdf'
                  );
                }
              "
              >Phomemo P831 Manual</a
            >
          </div>
          <hr
            style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
            v-show="!isMobile()"
          />
          <p>
            Phomemo P831 thermal ribbon and copy paper, Please click below Link:
          </p>
          <div class="linkDiv" ref="howToVideosRef">
            <a
              title="Click to learn more"
              @click="
                () => {
                  window.open('https://www.amazon.com/dp/B0C4TWXKYY');
                }
              "
              >Phomemo P831 thermal ribbon</a
            >
            <p>
              <a
                href="https://www.amazon.com/dp/B0C4XWXV2P"
                target="_blank"
                title="Click to learn more"
                >US Letter Copy Paper (8.5" x 11")</a
              >
            </p>
            <p>
              <a
                href="https://www.amazon.com/dp/B0C4XWXV2P?th=1"
                target="_blank"
                title="Click to learn more"
                >A4 Copy Paper (8.26" x 11.69")</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/videosIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">HOW-TO VIDEOS</div>
      </div>
      <br />

      <div class="videosDivE">
        <div class="leftDiv">
          <img
            class="videoLogoImg"
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 0 auto"
          />
          <a class="a-link">For Windows</a>
        </div>
        <div class="centerDiv">
          <p>Windows 7 (32 and 64 bit)</p>
          <p>Windows 8 (32 and 64 bit)</p>
          <p>Windows 10 (32 and 64 bit)</p>
          <p>Windows 11 (64 bit)</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="P831_windowsVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_win_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Mac</a>
        </div>
        <div class="centerDiv">
          <p>MacOS 10.14</p>
          <p>MacOS 10.15</p>
          <p>MacOS 10.11</p>
          <p>MacOS 12</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="P831_macVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_mac_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />

      <div class="videosDivE">
        <div class="leftDiv" style="padding-top: 3%">
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/chrome.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Chrome OS</a>
        </div>
        <div class="centerDiv" style="padding-top: 6%">
          <p>Download Extension For Chrome OS</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="P831_chromeVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/M08F/Chorme%20OS.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/pm246sLinux.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Linux</a>
        </div>
        <div class="centerDiv" style="padding-top: 5%">
          <p>Download Driver For Linux System</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="P831_linuxVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/pm246s_linux.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">APP for Smart Phone</a>
        </div>
        <div class="centerDiv" style="padding-top: 3%">
          <p>Phomemo App For IOS Device</p>
          <p>Phomemo App For Android device</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="P831_APPVideo"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/P831AppGuideVideo.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv" ref="driversRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/driversIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">DRIVERS</div>
      </div>
      <div class="downloadTitleBar">
        <span>P831 series Driver setup package (Windows & Windows ARM)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          @click="
            () => {
              refreshRecord({ key: 'P831_windowsDrivers' });
              window.open(
                'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Win.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size">(3.08 MB)</span>
      </div>
      <div class="downloadText">
        <p>
          OPERATING SYSTEM: Windows 7, Windows 8, Windows 10(32 and 64 bit)
          Windows 11(64 bit)
        </p>
      </div>
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />
      <!-- <div class="downloadTitleBar">
        <span>P831 series Driver setup package (Windows ARM)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'P831_ARMDrivers' });
              window.open(
                'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_WIN-ARM_EN.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size" style="top: 31px"
          >(1.47 MB)</span
        >
      </div>
      <br v-show="!isMobile()" />
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      /> -->

      <div class="downloadTitleBar">
        <span>P831 series Driver setup package (Mac)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          @click="
            () => {
              refreshRecord({ key: 'P831_macDrivers' });
              window.open(
                'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Mac.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size">(40.10 MB)</span>
      </div>
      <div class="downloadText">
        <p>OPERATING SYSTEM: macOS 10.14, macOS 10.15, macOS 10.11, macOS 12</p>
      </div>
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>P831 Series Extension setup (Chrome OS)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'P831_chromeDrivers' });
              window.open(
                'https://chrome.google.com/webstore/detail/labelife/fahkjfnppokdemlfodklgmdklmcllidl'
              );
            }
          "
        >
          CLICK HERE
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <!-- <span class="showSizeDiv" title="File Size">(528 KiB)</span> -->
      </div>
      <br v-show="!isMobile()" />
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>P831 series Driver setup package (Linux)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'P831_linuxDrivers' });
              window.open(
                'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Linux.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size" style="top: 31px"
          >(1283 KB)</span
        >
      </div>

      <br v-show="!isMobile()" />
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>Download Extraction Tool</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'M08F_Download_Extraction_Tool' });
              window.open('https://www.win-rar.com/download.html?&L=0');
            }
          "
        >
          GET TOOL
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
      </div>
      <div class="downloadText" v-show="!isMobile()">
        <p>Unzip Your Driver Files for Installation</p>
      </div>
    </div>

    <div class="howToVideosDiv" style="margin-top: 40px" ref="appDownloadRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/driversIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">APP</div>
      </div>
      <div class="appDownloadContainer">
        <div class="everyItemArea">
          <img :src="appDownIcon" style="max-width: 150px" />
          <h3>Phomemo APP - IOS</h3>
          <p>Easily print from your iOS device with the Phomemo App</p>
          <p>
            <a
              title="Click to download"
              @click="
                () => {
                  refreshRecord({ key: 'P831_AppStore' });
                  window.open(
                    'https://apps.apple.com/us/app/phomemo/id1456102145'
                  );
                }
              "
              >LEARN MORE</a
            >
          </p>
        </div>
        <div class="dividerLineDiv"></div>
        <div class="everyItemArea">
          <img :src="appDownIcon" style="max-width: 150px" />
          <h3>Phomemo APP - Android</h3>
          <p>Easily print from your Android device with the Phomemo App</p>
          <p>
            <a
              title="Click to download"
              @click="
                () => {
                  refreshRecord({ key: 'P831_GooglePlay' });
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.quyin.phomemo'
                  );
                }
              "
              >LEARN MORE</a
            >
          </p>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv faqBarDiv" ref="blankTemplatesRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/faqsIcon.png"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">
          Download Blank Templates For P831
        </div>
      </div>
      <div
        style="
          font-size: 18px;
          font-weight: 700;
          margin-left: 14px;
          padding: 20px 0 10px 28px;
        "
      >
        Select Your Label Size：
      </div>
      <div class="blankTemplates">
        <div
          class="every-item-container"
          v-for="(item, index) in fileArr"
          :key="index"
        >
          <div class="img-container">
            <img
              :src="item.img"
              style="display: block; margin: 10px auto; max-width: 141px"
              title="Click to download"
              @click="
                () => {
                  refreshRecord({ key: `P831_blankTemplate${index + 1}` });
                  window.open(item.url);
                }
              "
            />
          </div>
          <div
            class="text-container"
            title="Click to download"
            @click="
              () => {
                window.open(item.url);
              }
            "
          >
            <p>
              <a>{{ item.text[0] }}</a>
            </p>
            <p>
              <a>{{ item.text[1] }}</a>
            </p>
            <p style="margin-top: 5px">
              <a>{{ item.text[2] }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv faqBarDiv" ref="faqRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/faqsIcon.png"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">FAQ</div>
      </div>
      <div class="faq-content-area" style="margin-top: 30px">
        <div class="faq-container">
          <div
            class="faq-item"
            v-for="(item, index) in faqDataApp"
            :key="index"
          >
            <div class="faq-title" @click="clickQuestion2(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/delIconImg.png"
                class="downArrow"
                v-show="activeQuestion2.index === index"
              />
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/addIconImg.png"
                class="downArrow"
                v-show="activeQuestion2.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion2.index === index"
                v-for="child in item.details"
              >
                <div class="content-title" v-html="child.theme"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--   联系方式 -->
    <div class="customServiceDiv">
      <div class="everyRow">
        Email：
        <a
          style="cursor: pointer; color: #1fc3ff"
          @click="
            () => {
              refreshRecord({ key: 'P831_email' });
              window.open('mailto:support@phomemo.com');
            }
          "
          >support@phomemo.com</a
        >
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">WhatsApp：+86 15338193665</div>
    </div>

    <div class="back-to-top-div">
      <a @click="backTop"><img :src="toTopIcon" /><br />Back to top</a>
    </div>
  </div>
</template>

<script>
import { refreshRecord } from "@/util.js";

const domainApp = "https://doc.labelife.net/upload/video/omezizy/faqImg/app/";
const faqDataApp = [
  {
    title: "1. Does the printer support double-sided printing?",
    details: [
      {
        theme:
          "Yes, our phomemo P831 is printed on copy paper using thermal transfer printing technology. Supports double-sided printing.",
        mgUrls: [],
      },
    ],
  },

  {
    title: "2. Do I need to replace the ink or ribbon regularly?",
    details: [
      {
        theme:
          "The P831 printer with thermal printing technology does not require additional consumables such as ink and ribbon.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "3. Why can't the P831 printer connect to my phone via Bluetooth?",
    details: [
      {
        theme:
          "Be sure to connect the Bluetooth in the Phomemo App interface and not in the phone settings.",
        imgUrls: [],
      },
    ],
  },
  {
    title:
      "4. Is the P831 printer connected to a computer wirelessly via Bluetooth?",
    details: [
      {
        theme:
          "The P831 printer can only be connected to a computer with a data cable. And before using it for the first time, please download and install the driver in the computer, otherwise it will not be able to connect normally.",
        imgUrls: [],
      },
    ],
  },

  {
    title:
      "5. I have installed the driver, but the printer still won't connect to the computer. How can I solve the problem?",
    details: [
      {
        theme:
          "Please check if the driver you installed corresponds to your computer program, then please download the latest driver from this page and try again.",
        imgUrls: [],
      },
    ],
  },

  {
    title: "6. What file formats can be printed?",
    details: [
      {
        theme:
          "The P831 printer can print common document and picture formats, such as WORD, TXT, PDF, JPG, etc. It also supports printing web content.",
        imgUrls: [],
      },
    ],
  },

  {
    title:
      "7. What should I do when the P831 ribbon breaks/bands out while printing?",
    details: [
      {
        theme:
          "It has been verified that the problem lies with the carbon  ribbon breaking inside the printer.",
        imgUrls: [],
      },
    ],
  },
  {
    title:
      "8. What should we do when the app indicates “carbon ribbon error, to replace the carbon ribbon, or to print thermal paper, remove the carbon ribbon and install it again according to the prompts.",
    details: [
      {
        theme:
          "1. Try to reinstall or replace the carbon ribbon to see if the prompt persists.",
        imgUrls: [],
      },
      {
        theme:
          "2. Check the app info page for firmware updates. (Updating to firmware version 3.0.0 can solve the issue.)",
        imgUrls: [],
      },
    ],
  },
  {
    title: "9. What to do when your print is not sharp/too light",
    details: [
      {
        theme: "1. Please try to increase print density in the app.",
        imgUrls: [],
      },
      {
        theme:
          "2. Try cleaning the print head. ipe the cutting parts of the printer, especially the black lines, to make sure there is no dirt on the print head.",
        imgUrls: [],
      },
      {
        theme:
          "3. Most of the unclear printouts are due to the low-quality original files. Please try to send me the printout for troubleshooting.",
        imgUrls: [],
      },
      {
        theme: "4. Try replacing the carbon ribbon.",
        imgUrls: [],
      },
      {
        theme:
          "5. Please check the battery level of the printer. If it is lower than 10%, please charge it in time.",
        imgUrls: [],
      },
    ],
  },
  {
    title:
      "10. What should you do when unable to detect that the cover is closed",
    details: [
      {
        theme:
          "Please try to press down firmly on the cover and check if the app displays any error message. Please try multiple times.",
        imgUrls: [],
      },
      {
        theme:
          "If the above methods still do not solve your problem, please provide us with your order number, purchase date, and purchase platform.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "11. M832, P831, M08F Difference",
    details: [
      {
        theme:
          "1. The M832 and P831 are both thermal printers. There is no need to change the ink, just the thermal paper.",
        imgUrls: [],
      },
      {
        theme:
          "2. M832 can support printing A4, Letter size paper and also 53/80/110mm size paper. The M832 supports printing paper rolls.",
        imgUrls: [],
      },
      {
        theme:
          "3. P831 A4 version can only print A4 paper, does not support printing other sizes of paper. P831 supports printing paper only, not paper rolls.",
        imgUrls: [],
      },
      {
        theme:
          "4. There is also a difference between the regular A4 version and the Letter version. The sizes of the two versions are not universal. The A4 size can only print A4 paper and the Letter size can only print  Letter paper.",
        imgUrls: [],
      },
      {
        theme:
          "5. The P831 supports printing on regular A4 paper. It has a different printing technology principle from the P831 and M832, which is thermal transfer technology. Paper sizes supported by the P831 include Letter, A4, B5, and A5. ",
        imgUrls: [],
      },
      {
        theme:
          "However, the P831 does not support thermal paper printing, only plain paper printing.",
        imgUrls: [],
      },
      {
        theme:
          "6. The built-in ribbon can print approximately 45 sheets of A4 paper. The ribbon needs to be replaced after use.",
        imgUrls: [],
      },
      {
        theme:
          "However, if you want to print tattoo paper, P831 is recommended. M832 and P831 do not support printing tattoo paper.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "12. Phomemo P831 printer can play ordinary copy paper?",
    details: [
      {
        theme:
          "Yes, P831 can be very good at ordinary copy paper for printing, you can also choose to buy phomemo printing paper, print better!",
        imgUrls: [],
      },
    ],
  },
];
const fileArr = [
  {
    img: "https://pages.phomemo.com/resources/2x5.png",
    url: "https://pages.phomemo.com/resources/2x5.docx",
    text: ["50.8mm x 101.6mm", '(2" x 4")', "10per Sheet White"],
  },
  {
    img: "https://pages.phomemo.com/resources/2x7.png",
    url: "https://pages.phomemo.com/resources/2x7.docx",
    text: ["38.1mm x 99.1mm", '(1-1/2" x 4")', "14per Sheet White"],
  },
  {
    img: "https://pages.phomemo.com/resources/3x7.png",
    url: "https://pages.phomemo.com/resources/3x7.docx",
    text: ["38.1mm x 63.5mm", '(1-1/2" x 2-1/2")', "21per Sheet White"],
  },
  {
    img: "https://pages.phomemo.com/resources/3x10.png",
    url: "https://pages.phomemo.com/resources/3x10.docx",
    text: ["25.4mm x 66.8mm", '(1" x 2-5/8")', "30per Sheet White"],
  },
  {
    img: "https://pages.phomemo.com/resources/4x20.png",
    url: "https://pages.phomemo.com/resources/4x20.docx",
    text: ["12.7mm x 44.45mm", '(0-1/2" x 1-3/4")', "80per Sheet White"],
  },
];

const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
export default {
  name: "newP831",
  props: {},
  data() {
    return {
      faqDataApp,
      activeQuestion2: {},
      isMobile,
      window,
      appDownIcon: require("@/assets/appDownIcon.jpg"),
      clickName: "",
      toTopIcon: require("@/assets/toTopIcon.png"),
      refreshRecord,
      fileArr,
    };
  },
  mounted() {
    // refreshRecord({ key: 'P831_quickStartGuide' });
    this.listenVideo("P831_macVideo");
    this.listenVideo("P831_windowsVideo");
    this.listenVideo("P831_chromeVideo");
    this.listenVideo("P831_linuxVideo");
    this.listenVideo("P831_APPVideo");
  },
  methods: {
    listenVideo(videoId) {
      document.getElementById(videoId).addEventListener("play", function () {
        // console.log("视频开始播放了！");
        refreshRecord({ key: videoId });
      });
    },
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
        refreshRecord({ key: "P831_FAQ" + (index + 1) });
      } else this.activeQuestion2 = {};
    },
    backTop() {
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      };
      scrollToTop();
      this.clickName = "";
    },

    turnToItem(refName = "") {
      const ref = this.$refs[refName];
      this.clickName = refName;
      if (ref && ref.scrollIntoView) ref.scrollIntoView();
    },
  },
};
</script>

<style lang="less" src="./m08f_2.less" />



// WEBPACK FOOTER //
// src/view/guides/newP831.vue